/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'leftSideNav.mydashboard',
        subtitle: 'leftSideNav.mydashboardUniqueDesign',
        type: 'group',
        icon: 'tablericons_outline:home',
        children: [
            {
                id: 'dashboards.endcustomer',
                title: 'leftSideNav.endCustomer',
                type: 'basic',
                icon: 'tablericons_outline:adjustments',
                link: '/dashboards/project',
            },
            // {
            //     id: 'dashboards.partner',
            //     title: 'Partner',
            //     type: 'basic',
            //     icon: 'tablericons_outline:heart-handshake',
            //     link: '/dashboards/partner',
            // },
            // {
            //     id: 'dashboards.trader',
            //     title: 'Trader',
            //     type: 'basic',
            //     icon: 'tablericons_outline:chart-histogram',
            //     link: '/dashboards/finance',
            // },
            // {
            //     id: 'dashboards.configurator',
            //     title: 'ECS Web App',
            //     type: 'basic',
            //     icon: 'tablericons_outline:battery-3-up',
            //     link: '/dashboards/configurator',
            // },
        ],
    },
    {
        id: 'account',
        title: 'leftSideNav.myAccount',
        subtitle: 'leftSideNav.personalSettings',
        type: 'group',
        icon: 'tablericons_outline:home',
        children: [
            {
                id: 'account.profile',
                title: 'leftSideNav.profileSettings',
                type: 'basic',
                icon: 'tablericons_outline:user-circle',
                link: '/pages/settings',
            },
            // {
            //     id: 'account.company',
            //     title: 'Company settings',
            //     type: 'basic',
            //     icon: 'tablericons_outline:building-skyscraper',
            //     link: '/pages/settings',
            // },
            // {
            //     id: 'account.projects',
            //     title: 'My Projects',
            //     type: 'basic',
            //     icon: 'tablericons_outline:adjustments',
            //     link: '/account/projects',
            // }

            // , {
            //     id: 'account.mailbox',
            //     title: 'My Inbox',
            //     type: 'basic',
            //     icon: 'tablericons_outline:mail',
            //     link: '/apps/mailbox',
            // },
        ],
    },
    {
        id: 'infohub',
        title: 'Information hub',
        subtitle: 'dashboard.sideNav.inforamtionHub.subTitle',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            // {
            //     id: 'infohub.use-cases',
            //     title: 'Use Cases',
            //     type: 'basic',
            //     icon: 'tablericons_outline:mood-heart',
            //     link: '/apps/use-cases',
            // },
            // {
            //     id: 'infohub.scrumboard',
            //     title: 'Media',
            //     type: 'basic',
            //     icon: 'tablericons_outline:circle-caret-right',
            //     link: '/apps/media-manager',
            // }, {
            // id: 'support.helpcenter',
            // title: 'Support',
            // type: 'collapsable',
            // icon: 'tablericons_outline:help-hexagon',
            // link: '/apps/help-center',
            // children: [
            //     {
            //         id: 'support.home',
            //         title: 'Home',
            //         type: 'basic',
            //         link: '/apps/help-center'
            //     },

            //                 {
            //                     id: 'support.faqs',
            //                     title: 'FAQs',
            //                     type: 'basic',
            //                     link: '/apps/help-center/faqs'
            //                 },
            //                 {
            //                     id: 'support.guide',
            //                     title: 'Guide',
            //                     type: 'basic',
            //                     link: '/apps/help-center/guides'
            //                 },
            {
                icon: 'tablericons_outline:help-hexagon',
                id: 'support.contact',
                title: 'dashboard.sideNav.contact',
                type: 'basic',
                link: '/apps/help-center/support'
            }
            // ]

            // }
            // , {
            //             id: 'account.file-manager',
            //             title: 'My Documents',
            //             type: 'basic',
            //             icon: 'tablericons_outline:clipboard-text',
            //             link: '/apps/file-manager',
            //         }, {
            //             id: 'account.file-manager',
            //             title: 'Notifications',
            //             type: 'basic',
            //             icon: 'tablericons_outline:clipboard-text',
            //             link: '/apps/file-manager',
            //         },
            //         // {
            //         //     id: 'infohub.academy',
            //         //     title: 'Academy',
            //         //     type: 'basic',
            //         //     icon: 'tablericons_outline:school',
            //         //     link: '/apps/academy',
            //         // },
            //         // {
            //         //     id: 'infohub.your-partner',
            //         //     title: 'Your Partner',
            //         //     type: 'basic',
            //         //     icon: 'tablericons_outline:partner',
            //         //     link: '/apps/partners',
            //         // }
        ],
    },
    // {
    //     id: 'pages',
    //     title: 'Products & Services',
    //     subtitle: 'All about TESVOLT products',
    //     type: 'group',
    //     icon: 'heroicons_outline:document',
    //     children: [
    //         {
    //             id: 'pages.activities',
    //             title: 'Products',
    //             type: 'collapsable',
    //             icon: 'tablericons_outline:battery-3-up',
    //             link: '/pages/activities',
    //             children: [
    //                 {
    //                     id: 'products.aseries',
    //                     title: 'A-series',
    //                     type: 'basic',
    //                     link: '/a-series'
    //                 }, {
    //                     id: 'products.eseries',
    //                     title: 'E-series',
    //                     type: 'collapsable',
    //                     link: '/e-series',
    //                     children: [
    //                         {
    //                             id: 'products.aseries.cabinets',
    //                             title: 'TESVOLT E-Series Cabinet Systems',
    //                             type: 'basic',
    //                             link: '/e-series/cabinet',
    //                         }, {
    //                             id: 'products.aseries.containers',
    //                             title: 'TESVOLT E-Series Container Systems',
    //                             type: 'basic',
    //                             link: '/e-series/container',

    //                         }
    //                     ]
    //                 }
    //             ]
    //         },
    //         {
    //             id: 'pages.authentication',
    //             title: 'Applications',
    //             type: 'collapsable',
    //             icon: 'tablericons_outline:layout-grid-add-up',
    //             children: [
    //                 {
    //                     id: 'pages.authentication.sign-in',
    //                     title: 'Free Basic Version',
    //                     type: 'basic',
    //                     link: '/free-basic',

    //                 },
    //                 {
    //                     id: 'pages.authentication.sign-up',
    //                     title: 'Fee-Based Pro Version',
    //                     type: 'basic',
    //                     link: '/fee-based',
    //                 }
    //             ],
    //         },
    //         {
    //             id: 'pages.ems',
    //             title: 'EMS',
    //             type: 'basic',
    //             icon: 'tablericons_outline:plug',
    //             link: '/pages/maintenance',
    //         },
    //         {
    //             id: 'pages.hyve',
    //             title: 'HYVE',
    //             type: 'basic',
    //             icon: 'tablericons_outline:chart-histogram',
    //             link: '/pages/maintenance',
    //         },
    //         {
    //             id: 'pages.marketingshop',
    //             title: 'Marketing Shop',
    //             type: 'basic',
    //             icon: 'tablericons_outline:shopping-bag',
    //             link: '/pages/maintenance',
    //         },
    //     ],
    // },
    {
        id: 'divider-1',
        type: 'divider',
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        tooltip: 'Dashboards',
        type: 'aside',
        icon: 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'Apps',
        tooltip: 'Apps',
        type: 'aside',
        icon: 'heroicons_outline:qrcode',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'pages',
        title: 'Pages',
        tooltip: 'Pages',
        type: 'aside',
        icon: 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'UI',
        tooltip: 'UI',
        type: 'aside',
        icon: 'heroicons_outline:rectangle-stack',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Navigation',
        tooltip: 'Navigation',
        type: 'aside',
        icon: 'heroicons_outline:bars-3',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'DASHBOARDS',
        type: 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'APPS',
        type: 'group',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'others',
        title: 'OTHERS',
        type: 'group',
    },
    {
        id: 'pages',
        title: 'Pages',
        type: 'aside',
        icon: 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'User Interface',
        type: 'aside',
        icon: 'heroicons_outline:rectangle-stack',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Navigation Features',
        type: 'aside',
        icon: 'heroicons_outline:bars-3',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboards',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'apps',
        title: 'Apps',
        type: 'group',
        icon: 'heroicons_outline:qrcode',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'pages',
        title: 'Pages',
        type: 'group',
        icon: 'heroicons_outline:document-duplicate',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'user-interface',
        title: 'UI',
        type: 'group',
        icon: 'heroicons_outline:rectangle-stack',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
    {
        id: 'navigation-features',
        title: 'Misc',
        type: 'group',
        icon: 'heroicons_outline:bars-3',
        children: [], // This will be filled from defaultNavigation so we don't have to manage multiple sets of the same navigation
    },
];
